export const getFaqIcon = (question: string): string => {
  const q = question.toLowerCase();
  if (q.includes('prescription') || q.includes('label')) return '📋';
  if (q.includes('vial') || q.includes('bottle')) return '🧪';
  if (q.includes('when') || q.includes('how long') || q.includes('time')) return '🕒';
  if (q.includes('oral') || q.includes('pill')) return '💊';
  if (q.includes('supplies') || q.includes('equipment')) return '🛠️';
  if (q.includes('dose') || q.includes('dosage') || q.includes('units')) return '💉';
  if (q.includes('start') || q.includes('beginning')) return '🚀';
  if (q.includes('problem') || q.includes('help') || q.includes('issue')) return '🤨';
  if (q.includes('understand') || q.includes('explain')) return '🤔';
  return '❓';
};

// Helper function to create a clean description from markdown content
export const getCleanDescription = (content: string, fallback: string): string => {
  if (!content || content.trim() === '') {
    return fallback;
  }

  // Strip markdown formatting and HTML tags
  let cleanText = content
    .replace(/<style[^>]*>[^<]*<\/style>/g, '') // Remove inline CSS
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/#{1,6}\s+/g, '') // Remove headers
    .replace(/\*\*([^*]+)\*\*/g, '$1') // Remove bold
    .replace(/\*([^*]+)\*/g, '$1') // Remove italic
    .replace(/`([^`]+)`/g, '$1') // Remove inline code
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // Remove links, keep text
    .replace(/\n\n+/g, ' ') // Replace multiple newlines with space
    .replace(/\n/g, ' ') // Replace single newlines with space
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim();

  // Take first 150 characters and add ellipsis if truncated
  if (cleanText.length <= 150) {
    return cleanText;
  }

  return cleanText.substring(0, 147).trim() + '...';
};
